export const formatFullnameToUppercase = (value: string) => {
  const normalized = value.replace(/\s+/g, ' ').trim();
  return normalized
    .split(' ')
    .map((w) => w[0].toUpperCase() + w.slice(1))
    .join(' ');
};
